<script>
import { RouterLink } from "vue-router";

import { useSearchRoute } from "@/common/composables/use-search-route";

import { findWordclass } from "./wordclassMapper";

export default {
  name: "ArticleSubLemmas",
  components: {
    RouterLink
  },
  props: {
    sublemmas: {
      type: Array,
      required: true
    }
  },
  methods: {
    getSearchRoute(searchWord) {
      return useSearchRoute(this.$router).getSearchRoute(searchWord);
    },
    expandWordclass(wordclass) {
      return findWordclass(wordclass);
    }
  }
};
</script>

<template>
  <div class="article-content__body-container">
    <div class="article-content__politiken-box">
      <div class="article-content__politiken-box-header article-content__politiken-box-header">
        Afledning:
      </div>
      <div class="article-content__politiken-box-content">
        <div
          v-for="(sublemma, sublemmaIndex) in sublemmas"
          :key="sublemmaIndex"
          :class="{ 'mb-3': sublemmas.length > sublemmaIndex + 1 }"
        >
          <template v-if="sublemma.derivation">
            <RouterLink
              v-if="sublemma.reference"
              :to="getSearchRoute(sublemma.derivation)"
              class="article-content__politiken-box-content-text article-content__politiken-box-content-text--link"
              >{{ sublemma.derivation }}</RouterLink
            >
            <span
              v-else
              class="article-content__politiken-box-content-text article-content__politiken-box-content-text--prominent"
              >{{ sublemma.derivation }}</span
            >
          </template>

          <template v-if="sublemma.variant">
            <span
              class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained article-content__politiken-box-content-text--primary"
              >el.</span
            >
            <span
              class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained article-content__politiken-box-content-text--prominent"
              >{{ sublemma.variant }}</span
            >
          </template>

          <span
            v-if="sublemma.wordclass"
            class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained article-content__politiken-box-content-text--light article-content__politiken-box-content-text--italic"
            >{{ expandWordclass(sublemma.wordclass) }}</span
          >
          <span
            v-if="sublemma.flexion"
            class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained article-content__politiken-box-content-text--light article-content__politiken-box-content-text--italic"
            >({{ sublemma.flexion
            }}<template v-if="sublemma.flexionTwo">
              <span
                class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained"
                >el.</span
              >
              <span
                class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained"
                >{{ sublemma.flexionTwo }}</span
              ></template
            >)</span
          >

          <span
            v-if="sublemma.example"
            class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained article-content__politiken-box-content-text--light article-content__politiken-box-content-text--italic"
            v-html="sublemma.example"
          ></span>
        </div>
      </div>
    </div>
    <div class="article-content__spacer"></div>
  </div>
</template>
